import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { disputeShape } from '../../../utils/propTypes';
import { prettifyDate } from '../../../utils/string';
import { getDisputePDF } from '../chargebackActions';
import { getDisputePdfData, getDisputePdfErrorMessage, getIsDisputePdfLoading } from '../chargebackEntity';
import { connect } from 'react-redux';
import './ActivityRow.scss';
import PdfActions from '../../Actions/PdfActions/PdfActions';

export class ActivityRow extends Component {
    static propTypes = {
        chargebackId: PropTypes.number,
        dispute: disputeShape,
        error: PropTypes.string,
        isPdfLoading: PropTypes.bool,
        onGetDisputePdf: PropTypes.func,
        pdfData: PropTypes.string,
        merchantId: PropTypes.number
    };

    render() {
        const date = prettifyDate(this.props.dispute.createdAt, { dateTimeFormatOutput: 'MM/DD/YYYY hh:mm a' });
        const { chargebackId, dispute, error, isPdfLoading, pdfData, merchantId } = this.props;

        const merchantIdStr = merchantId.toString();
        let cbMessage;
        if (merchantIdStr.startsWith('9')) {
            cbMessage = 'If you have any questions about a chargeback, please contact the Chargeback Department at 866-637-5467. Please have the chargeback case number ready to provide.';
        } else if (merchantIdStr.startsWith('5') || merchantIdStr.startsWith('8') || merchantIdStr.startsWith('0008')) {
            cbMessage = 'If you have any questions about a chargeback, please contact the Chargeback Department at 800-858-1166 and choose option 1. Please have the chargeback case number ready to provide.';
        } else {
            cbMessage = 'If you have any questions about a chargeback, please contact the Chargeback Department at 866-637-5467. Please have the chargeback case number ready to provide.';
        }

        return (
            <div className="activity-row">
                <div className="activity-details">
                    <div className="activity-details-container">
                        <div className="activity-description">A dispute was submitted.</div>
                        <div className="activity-date">{date}</div>
                    </div>
                    <div className="pdf-actions-wrapper">
                        <PdfActions
                            error={error}
                            filename={`${dispute.merchantId}-${chargebackId}`}
                            isPdfLoading={isPdfLoading}
                            onGetPdf={() => this.props.onGetDisputePdf(chargebackId, dispute.merchantId)}
                            pdfData={pdfData}
                            shouldControlAction
                            shouldControlToast
                        />
                    </div>
                    <div>
                        *Once submitted, documents are provided to a third party. {cbMessage}
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        error: getDisputePdfErrorMessage(state, ownProps.chargebackId),
        isPdfLoading: getIsDisputePdfLoading(state, ownProps.chargebackId),
        pdfData: getDisputePdfData(state, ownProps.chargebackId)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onGetDisputePdf: (chargebackId, merchantId) => dispatch(getDisputePDF(chargebackId, merchantId))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ActivityRow);
